export default __webpack_public_path__ + "static/media/resources.2b253ef0.svg";